import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { documentTitleForAppPath } from '../lib/appDocumentTitle';

/** Keeps /app tab titles stable when react-helmet unmounts (HMR, Suspense). */
export default function AppDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith('/app')) return;
    document.title = documentTitleForAppPath(pathname);
  }, [pathname]);

  return null;
}
